{
  "id": "servingTray",
  "name": "Serving Tray",
  "builds": "product",
  "category": "fineGoods",
  "note": "The rail wrap only closes on a 12\" bottom.",
  "skill": "trayWork",
  "duration": 35,
  "offeredBy": "bench",
  "fastener": "nails",
  "value": 18,
  "widthIn": 12,
  "heightIn": 24,
  "slots": [
    {
      "id": "bottom-0",
      "role": "bottom",
      "part": {
        "widthIn": 12,
        "lengthIn": 24,
        "thicknessQ": 4
      },
      "stock": {
        "type": "panel",
        "species": "realWood",
        "surface": "sanded",
        "thickness": [3, 4]
      },
      "xIn": 6,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 24,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 0.5,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 1
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 1,
        "lengthIn": 24,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 11.5,
      "yIn": 12,
      "angleDeg": 180,
      "zIn": 1
    },
    {
      "id": "end-0",
      "role": "end",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 0.5,
      "angleDeg": 90,
      "zIn": 1
    },
    {
      "id": "end-1",
      "role": "end",
      "part": {
        "widthIn": 1,
        "lengthIn": 12,
        "thicknessQ": 1,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "realWood",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 23.5,
      "angleDeg": 270,
      "zIn": 1
    }
  ],
  "fasteners": [
    {
      "xIn": 0.5,
      "yIn": 6
    },
    {
      "xIn": 0.5,
      "yIn": 18
    },
    {
      "xIn": 11.5,
      "yIn": 6
    },
    {
      "xIn": 11.5,
      "yIn": 18
    },
    {
      "xIn": 0.5,
      "yIn": 0.5
    },
    {
      "xIn": 0.5,
      "yIn": 23.5
    },
    {
      "xIn": 11.5,
      "yIn": 0.5
    },
    {
      "xIn": 11.5,
      "yIn": 23.5
    }
  ]
}
